import { jsxs as r, Fragment as t, jsx as C } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ r(t, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M15.5355 5.46447C16.4732 6.40215 17 7.67392 17 9C17.0002 10.1527 16.6022 11.27 15.8733 12.1629C15.1444 13.0558 14.1294 13.6695 13 13.9V15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15V13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.5933 12 13.1734 11.8241 13.6667 11.4944C14.1601 11.1648 14.5446 10.6962 14.7716 10.1481C14.9987 9.59987 15.0581 8.99667 14.9424 8.41473C14.8266 7.83279 14.5409 7.29824 14.1213 6.87868C13.7018 6.45912 13.1672 6.1734 12.5853 6.05764C12.0033 5.94189 11.4001 6.0013 10.8519 6.22836C10.3038 6.45542 9.83524 6.83994 9.50559 7.33329C9.17595 7.82664 9 8.40666 9 9C9 9.26522 8.89464 9.51957 8.70711 9.70711C8.51957 9.89464 8.26522 10 8 10C7.73478 10 7.48043 9.89464 7.29289 9.70711C7.10536 9.51957 7 9.26522 7 9C7 7.67392 7.52678 6.40215 8.46447 5.46447C9.40215 4.52678 10.6739 4 12 4C13.3261 4 14.5979 4.52678 15.5355 5.46447Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z",
      fill: "currentColor"
    }
  )
] });
export {
  e as default
};
